<template>
    <div>
        <template v-if="seen">
            <el-carousel :height="computeHeight">
                <el-carousel-item v-for="(item, index) in sliders" :key="index">
                    <img :src="item.img"  class="slider_img" style="object-fit:cover;">
                
                </el-carousel-item>
            </el-carousel>

            <div class="contentindex-box" style="display: none;"> 
                <div class="index-width"> 
                <h2>
                    <!-- <img src="images/newspic-tit.png"> -->
                    <div class="mainTitle">
                        <div class="titleText">新闻资讯</div>
                        <div class="titleTips">News Information</div>
                    </div>
                </h2> 
                <div class="c-box1"> 
                <dl> 
                <dt>
                    <span>媒体报道</span>
                    <a @click="goNew('1')">更多</a>
                </dt> 
                <dd> 
                    
                    <ul> 
                        <li  @click="goNewDetails({id:'1',type:'1'})"> 
                            <div class="showpic"> 
                                <a> <img src="../../static/images/16081861736850.jpg" onerror="this.src='/index/statics/images/nopic.gif'"></a>
                            </div> 
                            <div class="showtxt"> 
                            <h3><a title="百台传祺GE3交付小易出行 打造高品质共享汽车">百台传祺GE3交付小易出行 打造高品质共享汽车</a></h3> 
                            <p>人民网讯：12月21日，由顺义区人民政府主办的创新型产业集群和2025示范区重点项目推介会举行。北京市经...</p> 
                            </div> 
                        </li> 
                    <li  @click="goNewDetails({id:'2',type:'1'})"> 
                        <div class="showpic"> 
                        <a > <img src="../../static/images/16081862005072.jpg" onerror="this.src='/index/statics/images/nopic.gif'"></a>
                        </div> 
                        <div class="showtxt"> 
                        <h3><a title="顺义区举办创新型产业集群和2025示范区重点项目推介会">顺义区举办创新型产业集群和2025示范区重点项目推介会</a></h3> 
                        <p>人民网讯：12月21日，由顺义区人民政府主办的创新型产业集群和2025示范区重点项目推介会举行。北京市经...</p> 
                        </div> 
                    </li> 
                    <li  @click="goNewDetails({id:'3',type:'1'})"> 
                        <div class="showpic"> 
                        <a > <img src="../../static/images/16081863828975.png" onerror="this.src='/index/statics/images/nopic.gif'"></a>
                        </div> 
                        <div class="showtxt"> 
                        <h3><a title="未来充电站什么样？来看德国媒体追捧全球最大光伏充电站">未来充电站什么样？来看德国媒体追捧全球最大光伏充电站</a></h3> 
                        <p>北京时间12月13日上午10点，德国电视一台ARD记者来到这里松江欢乐谷星空光伏充电站采访。德国电视一台是德国全国性公共电视台，于1954年11月正式开播，1967年8月采用本国的帕尔制式播出彩色节目，新闻中心设在汉堡，电视节目部设在慕尼黑。</p> 
                        </div> 
                    </li> 
                    </ul> 
                </dd> 
                </dl> 
                </div> 
                <div class="c-box2"> 
                <dl> 
                <dt>
                    <span>公司新闻</span>
                    <a  @click="goNew('2')">更多</a>
                </dt> 
                <dd> 
                    <ul> 
                    <li @click="goNewDetailsCom({id:'19',type:'2'})"><a title="中国充电联盟召开2018年度工作会议">中国充电联盟召开2018年度工作会议</a><span>2021-01-22</span> </li> 
                    <li @click="goNewDetailsCom({id:'20',type:'2'})"><a title=" 集团·广汽新能源开展战略合作 携手提升用户使用体验"> 集团·广汽新能源开展战略合作 携手提升用户使用体验</a><span>2020-12-27</span> </li> 
                    <li @click="goNewDetailsCom({id:'21',type:'2'})"><a  title=" 全产业链再发力，年产值45亿项目签约顺义"> 全产业链再发力，年产值45亿项目签约顺义</a><span>2020-12-22</span> </li> 
                    <li  @click="goNewDetailsCom({id:'22',type:'2'})"><a title="创新有道 实践为基 绿色出行大有可为">创新有道 实践为基 绿色出行大有可为</a><span>2020-12-17</span> </li> 
                    </ul> 
                </dd> 
                </dl> 
                <dl> 
                <dt style="margin-top: 20px;">
                    <span>集团公告</span>
                    <a  @click="goNew('3')">更多</a>
                </dt> 
                <dd> 
                    <ul> 
                    </ul> 
                </dd> 
                </dl> 
                </div> 
                </div> 
            </div> 
            
            <div class="clearbox"></div> 
    
            <!-- 业务领域 -->
            <div class="Business-box">
                <h2><img src="../../static/images/fieldpic-tit.png" alt="业务领域"></h2>
            </div> 
            <div class="clearbox"></div> 
            <div class="clearbox"></div> 
        
            <div class="footerbox"> 
                <div class="index-width"> 
                    <div class="fott-box1"> 
                        <span> <img alt="" src="../../static/images/gongzhong.jpg" style="width: 110px; height: 110px;"> <em>关注微信</em> </span> 
                        <!-- <span> <img alt="" src="../../static/images/mobileCom.png" style="width: 110px; height: 110px;"> <em>手机网站</em> </span>  -->
                    </div> 
                    <div class="fott-box2"> 
                        <div class="box2-left">
                            <!-- <a href="./49.html">加入我们</a>|
                            <a href="./50.html">意见反馈</a> -->
                        </div> 
                        <div class="box2-right">
                            <span><a href="https://beian.miit.gov.cn" target="_blank">京ICP备2023006901号-4</a>|CopyRight© 2023  集团</span>
                        </div> 
                    </div> 
                </div> 
            </div> 
        </template>


        <template  v-if="!seen">
            <div class="mob-topImg">
                <img src="../../static/slider/newBanner.jpg" style="object-fit: cover;" alt="" srcset="">
            </div>
            <!-- <div class="mob-line"></div>
            <div class="mob-common">
                <div class="mob-title">媒体报道</div>
                <div class="mob-commonList" v-for="(item,index) in mobCommonList">
                    <div class="mob-listClass"  @click="goMobNewDetails({id:item.id,type:'1'})">
                        <div class="mob-listLeft">
                            <img :src="item.img" alt="" srcset="" style="object-fit: cover;">
                        </div>
                        <div class="mob-listRight">
                            <div class="mob-rightText">{{ item.title }}</div>
                            <div class="mob-rightDate">{{ item.date }}</div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="mob-line"></div> -->

            <!-- <div class="mob-common">
                <div class="mob-title">公司新闻</div>
                <div class="mob-commonList" >
                    <div class="mob-newsList" v-for="(item,index) in mobCommonNewsList" @click="goMobNewDetailsCom({id:item.id,type:'2'})">
                        <div class="mob-newsLeft">{{ item.text }}</div>
                        <div class="mob-newsRight">{{ item.date }}</div>
                    </div>
                </div>
            </div> -->

            <div class="mob-line"></div>

            <!-- <div class="mob-common">
                <div class="mob-title">集团公告</div>
                <div class="mob-commonList" >
                    
                </div>
            </div>

            <div class="mob-line"></div> -->

            <div class="mob-common">          
                <div class="mob-bussiness">
                    <div class="mob-busImg" v-for="(item,index) in businessImgDate" :key="index">
                        <img :src="item.img" alt="" srcset="">
                    </div>
                </div>
            </div>
            <div style="height:20px"></div>
        </template>
    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                seen: true,
                sliders: [],
                businessImgDate:[
                    // {index:"4-1",img:"http://picture.telluspowergreen.cn/skin/style2/images/business1.png"},  //充电桩销售业务
                    // {index:"4-2",img:"http://picture.telluspowergreen.cn/skin/style2/images/business4.png"},  //充电桩运营业务
                    // {index:"4-7",img:"http://picture.telluspowergreen.cn/skin/style2/images/business2.png"},
                    // {index:"4-4",img:"http://picture.telluspowergreen.cn/skin/style2/images/business3.png"},  //bibv光伏业务
                    // {index:"4-5",img:"http://picture.telluspowergreen.cn/skin/style2/images/business5.png"},
                    // {index:"4-8",img:"http://picture.telluspowergreen.cn/skin/style2/images/business6.png"},
                    // {index:"4-9",img:"http://picture.telluspowergreen.cn/skin/style2/images/business7.png"},
                ],
                images: [
                 
                ],
                products: [
                    {
                        img: [
                            {
                                left: require('../../static/other/1.jpg'), 
                                right: require('../../static/other/2.jpg'), 
                            },
                            {
                                left: require('../../static/other/3.jpg'), 
                                right: require('../../static/other/4.jpg'), 
                            },
                            {
                                left: require('../../static/other/5.jpg'), 
                                right: require('../../static/other/6.jpg'), 
                            }
                        ],
                        title: "手机端商品展示，强大的商品规格设计",
                        content: [
                            "商品热销分类显，分类导航显示所有分类", 
                            "热销商品优先排序 商城首页轮播自定义",
                            "单品、多规格、加料、属性、多价格展示",
                            "商品分类列表支持虚拟列表，滚动众享丝滑",
                            "无需注册会员，商品在线购买支付"
                        ]
                    }
                ],
                mobCommonNewsList:[
                    {id:'19',text:"中国充电联盟召开2018年度工作会议",date:"2021-01-22",type:'2'},
                    {id:'20',text:" 集团·广汽新能源开展战略合作 携手提升用户使用体验",date:"2020-12-27",type:'2'},
                    {id:'21',text:" 全产业链再发力，年产值45亿项目签约顺义",date:"2020-12-22",type:'2'},
                    {id:'22',text:"创新有道 实践为基 绿色出行大有可为",date:"2020-12-17",type:'2'},
                ],
                mobCommonList:[
                   
                ],
               
                carousel_height: '550px',
            }
        },
        methods: {
            goNewDetails(e){
                console.log(e)
                // let data = {
                //     id:e.id,
                //     type:e.type
                // }
                this.$router.push({name: "newsDetails",query:{data:e}});
                this.$store.commit('newSet','3-2')
            },
            goMobNewDetails(e){
                console.log(e)
                this.$router.push({name: "mobNewsDetails",query:{data:e}});
                this.$store.commit('newSet','3-2')
            },
            goNewDetailsCom(e){
                console.log(e)
                this.$router.push({name: "newsDetails",query:{data:e}});
                this.$store.commit('newSet','3-1')
            },
            goMobNewDetailsCom(e){
                console.log(e)
                this.$router.push({name: "mobNewsDetails",query:{data:e}});
                this.$store.commit('newSet','3-1')
            },
            
            goNew(e){
                if(e == '1'){
                    this.$store.commit('newSet','3-2')
                }else if(e == '2'){
                    this.$store.commit('newSet','3-1')
                }
                else if(e == '3'){
                    this.$store.commit('newSet','5')
                    this.$router.push({name: "notice"});
                    return;
                }
                
                this.$router.push({name: "news",query:{type:e}});
            },
            menuSeen(){
                // 屏幕尺寸
                let screenHeight=document.body.clientWidth;
                if(screenHeight>415){
                    this.seen=true;
                }else{
                    this.seen=false;
                }
            },
        },
        mounted() {
            this.menuSeen()
            this.sliders = [
                // {
                //     img: require("../../static/slider/a1.jpg")
                // },
                // {
                //     img: require("../../static/slider/a2.jpg")
                // },
                // {
                //     img: require('../../static/slider/a3.jpg')
                // },
                // {
                //     img: require('../../static/slider/a4.jpg')
                // }
                {
                    img: require('../../static/slider/banner1.jpg')
                },
                // {
                //     img: require('../../static/slider/banner2.jpg')
                // },
            ],
            this.mobCommonList = [
                    {id:"1",img:require("../../static/images/16081861736850.jpg"),type:"1",text:"人民网讯：12月21日，由顺义区人民政府主办的创新型产业集群和2025示范区重点项目推介会举行。北京市经...",title:"百台传祺GE3交付小易出行 打造高品质共享汽车",date:"2021/01/09"},
                    {id:"2",img:require("../../static/images/16081862005072.jpg"),type:"1",text:"人民网讯：12月21日，由顺义区人民政府主办的创新型产业集群和2025示范区重点项目推介会举行。北京市经...",title:"顺义区举办创新型产业集群和2025示范区重点项目推介会",date:"2020/12/26"},
                    {id:"3",img:require("../../static/images/16081863828975.png"),type:"1",text:"北京时间12月13日上午10点，德国电视一台ARD记者来到这里松江欢乐谷星空光伏充电站采访。德国电视一台是德国全国性公共电视台，于1954年11月正式开播，1967年8月采用本国的帕尔制式播出彩色节目，新闻中心设在汉堡，电视节目部设在慕尼黑。",title:"未来充电站什么样？来看德国媒体追捧全球最大光伏充电站",date:"2020/12/15"},
                ]
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
    }
</script>

<style scoped>
.mob-busImg{
    width: 47%;
    height: 1.4rem;
    margin-bottom:4px;
}
.mob-busImg img{
    width: 100%;
    height: 100%;
}
.mob-bussiness{
    padding: 0 0.5rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.mob-newsRight{
    color: #999;
    font-size: 0.34rem;
}
.mob-newsLeft{
    font-size: 0.38rem;
    color: #000;
    width: 80%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.mob-newsList{
    display: flex;
    justify-content: space-between;
    padding: 8px;
}
.mob-rightText{
    font-size: 0.4rem;
    color: #333;
}
.mob-rightDate{
    font-size: 0.3rem;
    color: #999;
}
.mob-listRight{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.mob-listLeft img{
    width: 2.6rem;
    height: 1.8rem;
    margin-right: 8px;
}
.mob-listClass{
    padding: 0.22rem 0.1rem;
    display: flex;
}
.mob-title{
    font-weight: 600;
    font-size: 0.45rem;
    color: #000;
    padding: 0.08rem 5%;
}
.mob-commonList{

}
.mob-common{

}
.mob-line{
    width: 100%;
    height: 0.08rem;
    background-color: #18D1BB;
    margin: 0.2rem 0;
}
.mob-topImg{
    margin-top: 0.3rem;
}
.mob-topImg img{
    width: 100%;
    height:10rem;
}
.footerbox .fott-box2 {
    width: 100%;
    float: left;
    height: 50px;
}
.footerbox .fott-box2 .box2-left {
    float: left;
    line-height: 50px;
    color: #e4e4e4;
    font-family: Tahoma;
}
.footerbox .fott-box2 .box2-left a {
    font-size: 14px;
    color: #181818;
    margin: 0 15px;
}
.footerbox .fott-box2 .box2-right {
    float: right;
    line-height: 50px;
    color: #e4e4e4;
    font-family: Tahoma;
}
.footerbox .fott-box2 .box2-right span {
    font-size: 14px;
    color: #181818;
    margin: 0 15px;
}
.footerbox {
    margin: 0 auto;
    width: 100%;
    overflow: hidden;
    background: url(../../static/images/bottom_bg.jpg) repeat-x left bottom;
}
.Business-box {
    margin: 0 auto;
    width: 100%;
    height: 580px;
    background: url(../../static/images/ywlypic.jpg) center top;
    overflow: hidden;
    position: relative;
}
.footerbox .fott-box1 span em {
    line-height: 30px;
    font-size: 20px;
    text-align: center;
    display: block;
    font-style: normal;
    color: #000;
}
.footerbox .fott-box1 {
    width: 100%;
    float: left;
    height: 180px;
    text-align: center;
}
.footerbox .fott-box1 span {
    display: inline-block;
    margin: 30px 20px 0;
}
img {
    vertical-align: middle;
    border: 0;
}
.index-width {
    width: 1000px;
    margin: 0 auto;
    position: relative;
}
.Business-box h2 {
    position: absolute;
    left: 0;
    top: 55px;
    text-align: center;
    width: 100%;
}
/*清除浮动*/
.clearbox {
	border-top: 1px solid transparent !important;
	margin-top: -1px !important;
	margin-top: 0px;
	clear: both;
	font-size: 0px;
	line-height: 0px;
	height: 0px;
	border: 0px;
	visibility: hidden;
}
.mainTitle{
    display: flex;
    flex-direction: column;
}
.titleTips{
    color: #898989;
    font-size: 16px;
}
.titleText{
    font-size: 34px;
    color: #18D1BB;
}
   .contentindex-box {
        margin: 10px auto;
        width: 100%;
        overflow: hidden;
    }
    .index-width {
        width: 1000px;
        margin: 0 auto;
        position: relative;
    }
    .contentindex-box h2 {
        margin: 40px 0;
        width: 100%;
        float: left;
        text-align: center;
    }
    .contentindex-box .c-box1 {
        width: 460px;
        float: left;
    }
    dl, dt, dd, img {
        margin: 0;
        padding: 0;
        border: 0;
    }
    .contentindex-box .c-box1 dl dt {
        width: 100%;
        height: 48px;
        background-color: #f8f8f8;
        padding: 0 10px;
        box-sizing: border-box;
    }
    .contentindex-box .c-box1 dl dt span {
        line-height: 48px;
        font-size: 18px;
        color: #000;
        float: left;
        margin-left: 10px;
    }
    .contentindex-box .c-box1 dl dt a {
        color: #666666;
        font-size: 14px;
        float: right;
        line-height: 48px;
    }
    .contentindex-box .c-box1 dl dd ul {
        width: 100%;
        float: left;
    }
    .contentindex-box .c-box1 dl dd ul li {
        width: 100%;
        float: left;
        margin: 17px 0;
    }
    .contentindex-box .c-box1 dl dd ul li .showpic {
        width: 116px;
        float: left;
    }
    a {
        color: #20366f;
        text-decoration: none;
    }
    .contentindex-box .c-box1 dl dd ul li .showpic img {
        width: 116px;
        height: 88px;
    }
    .contentindex-box .c-box1 dl dd ul li .showtxt {
        width: 325px;
        float: right;
    }
    .border_parent {
        width: 90%;
        margin: auto;
    }
    h1, h2, h3, h4, h5, h6 {
        margin: 0;
        padding: 0;
        font-size: 12px;
        font-weight: normal;
    }
    .contentindex-box .c-box1 dl dd ul li .showtxt h3 a {
        font-size: 14px;
        color: #000;
        font-weight: bold;
        height: 25px;
        display: block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
    }
    ul, ol, li {
        list-style: none;
        padding:0;
    }
    .contentindex-box .c-box1 dl dd ul li .showtxt p {
        font-size: 14px;
        width: 100%;
        color: #666666;
        line-height: 25px;
        height: 50px;
        margin: 5px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
    }
    .contentindex-box .c-box2 {
        width: 500px;
        float: right;
    }
    .contentindex-box .c-box2 dl {
        width: 100%;
        float: left;
    }
    .contentindex-box .c-box2 dl dt {
        width: 100%;
        height: 48px;
        background-color: #f8f8f8;
        padding: 0 10px;
        box-sizing: border-box;
    }
    .contentindex-box .c-box2 dl dt span {
        line-height: 48px;
        font-size: 18px;
        color: #000;
        float: left;
        margin-left: 10px;
    }
    .contentindex-box .c-box2 dl dt a {
        color: #666666;
        font-size: 14px;
        float: right;
        line-height: 48px;
    }
    .contentindex-box .c-box2 dl dd ul {
        width: 100%;
        float: left;
        margin: 15px 0;
        height: 128px;
    }
    .contentindex-box .c-box2 dl dd ul li {
        width: 100%;
        float: left;
        line-height: 32px;
        box-sizing: border-box;
        padding-left: 15px;
        background: url(../../static/images/don.gif) no-repeat 5px center;
    }
    .contentindex-box .c-box2 dl dd ul li a {
        float: left;
        font-size: 13px;
        color: #000;
    }
    
    .contentindex-box .c-box1 dl dd ul li .showtxt h3 a:hover{ color:#18D1BB;}
    .contentindex-box .c-box2 dl dd ul li .showtxt h3 a:hover{ color:#18D1BB;}
    .contentindex-box .c-box2 dl dd ul li a:hover{color:#18D1BB;}
    .contentindex-box .c-box2 dl dd ul li span {
        color: #898989;
        float: right;
    }
    .slider_img {
        height: 550px;
        width: 100%;
    }

    .solve {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        margin: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .border_one {
        margin-left: 0;
    }

    .border_img_parent {
        /* margin-top: 20px; */
        display: flex;
        justify-content: center;
    }

    .product_mobile_content {
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .product_mobile_img {
        width: 50%;
    }

    .product_mobile_title {
        font-weight: bold;
        text-align: center;
    }

    .product_pc_one {
        text-align: center;
        min-height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .product_font_style {
        font-size: 1.125em;
    }

    .product_pc_img {
        width: 100%
    }

    .product_pc_img_div {
        width: 50%;
        float: left;
        display: flex;
        align-items: center;
    }

    .product_pc {
        display: flex;
        width: 90%;
        margin: 20px auto;
        background: #F2F6FC;
        align-items: center;
    }

    .product_spec_title {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .cooperation_parent {
        display: flex;
        justify-content: center;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .border_spec {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 25%;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .about_me_p {
        font-size: 1.25em;
        font-weight: normal;
        padding: 0 20px;
        margin: 10px;
    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 10px;
        font-size: 1.125em;
        font-weight: bold;
        text-align: center;
    }

    .border_content_one {
        margin-top: 20px;
        font-size: 1.125em;
        text-align: center;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 25px;
        text-align: center;
    }

    .img_border {
         /* margin-top: 8px; */
         width: 100%;
            height: 100%;
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 35px;
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        text-align: center;
    }

    .border_spec_inner_last {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 25px;
        text-align: center;
    }

    .cooperation {
        margin-top: 30px;
        width: 100%;
    }

    .about_me {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        width: 100%;
    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        background: #F2F6FC;
    }

    .product_mobile_img_div {
        width: 50%;
        height: auto;
    }

    .product_mobile_content_one {
        margin-top: 20px;
        text-align: center;
    }

    .product_mobile_content_two {
        margin-top: 10px;
        text-align: center;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 250px;
            width: 100%;
        }


        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0;

        }

        .product_mobile {
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 15px;
        }

        .product_mobile_content_one {
            margin-top: 5px;
        }

        .product_mobile_content_two {
            margin-top: 5px;
        }

        .product_mobile_img_div {
            display: flex;
            width: 100%;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .product_mobile_img {
            float: left;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25em;
        }

        .product_font_style {
            font-size: 1em;
        }

        .product_pc_img {
            height: 280px;
            width: 320px;
        }

        .product_pc_img_div {
            width: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        .product_pc {
            display: flex;
            width: 90%;
            height: auto;
            margin: 20px auto;
            background: #F2F6FC;
            flex-direction: column;
        }

        .head-label {
            display: flex;
            margin-top: 10px;
        }

        .product_spec_parent {
            display: flex;
            width: 90%;
            align-items: center;
            justify-content: center;
            margin: 20px auto;
            height: auto;
            flex-direction: column;
        }

        .border_spec {
            float: left;
            height: auto;
            margin: 8px;
            width: 100%;
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }


        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125em;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125em;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125em;
            margin-bottom: 8px;
        }

        .img_border {
            margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .border_spec_inner_one {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 8px;
            /*background-color: aqua;*/
            height: 70px;
        }

        .border_spec_content_one {
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
        }

        .border_spec_inner_last {
            /*background-color: bisque;*/
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
            margin-bottom: 8px;
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            width: 100%;
        }
    }

    .border_spec_img {
        width: 75px;
        height: 55px;
        align-self: center
    }

    .font_size_24 {
        font-size: 1.5em;
    }
</style>